
import { useState, useEffect, useContext, createContext, useRef } from "react";

import { GoogleOAuthProvider } from '@react-oauth/google';
import { fetchAuthCredentials } from "../utilities/server-fetch";

import { FeatureTypeSelector, LoginMethod } from "@Beasted1010/pivotal-wisdom";

import { useUserUpdate } from "./UserContext";


export {
  OAuthContextProvider,
  useOAuth, useOAuthUpdate
};



const CLIENT_ID = "554576131061-aldegv7staqa8h045r7fjdo7es7cap4c.apps.googleusercontent.com";
const GOOGLE_OAUTH_SCRIPT_SOURCE = "https://accounts.google.com/gsi/client";


const OAuthContext = createContext<any>( null ); // TODO: Properly fill out
const OAuthUpdateContext = createContext<any>( null );


function useOAuth() {
  return useContext( OAuthContext );
}

function useOAuthUpdate() {
  return useContext( OAuthUpdateContext );
}




type OAuthProps = {
  children?: JSX.Element | JSX.Element[];
}


function OAuthContextProvider( {children}: OAuthProps ) {
  // Provider handles...

  // ... Creating State
  /*
  const [ GoogleLoginButton, setGoogleLoginButton ] = useState<any>(null); // TODO: Properly TYPE
  const [ facebookLoginButton, setFacebookLoginButton ] = useState<any>(null);

  const { updateUser } = useUserUpdate();
  const handleCredentialResponse = useCredentialResponseHandler( updateUser );
  const { GoogleAuth } = useGoogleAuth( handleCredentialResponse );
  */



  const [googleClientID, setGoogleClientID] = useState( "" );

  useEffect( () => {
    //setGoogleLoginButton( GoogleAuth );
    //console.log("SET GOOGLE AUTH COMPONENT WITH:", GoogleAuth);


    const fetchCredentials = async () => {
      const credentials = await fetchAuthCredentials( LoginMethod.GOOGLE );

      if( !credentials || !credentials.clientID ) {
        console.error( "Google Auth Failed - No Client ID Available" );
        return;
      }

      setGoogleClientID( credentials.clientID );
    }
    fetchCredentials();

    // Cleanup Function
    return () => {
      // TODO: Google Script
      //const googleScriptTag = document.querySelector( `script[src="${GOOGLE_OAUTH_SCRIPT_SOURCE}"]` );
      //if( googleScriptTag ) { document.body.removeChild( googleScriptTag ); console.log("SCIRPT REMOVED"); }
    };

  }, []);


  /* TODO: NOTE: Assuming it's okay to let CLIENT_ID be incorrect, site still works, but Google Auth might not, which is fine
  if( !googleClientID ) {
    return (
      <p>Loading...</p> // TODO: Consistent <Loading /> Component (perhaps have it as a Spinner)
    );
  }
  */

  // ... Persisting State down into Children
  return (
    //<OAuthContext.Provider value={ {GoogleLoginButton, facebookLoginButton} } >
    <OAuthContext.Provider value={ {} } >
      <OAuthUpdateContext.Provider value={ {} } >
        <GoogleOAuthProvider clientId={googleClientID}>
            {children}
        </GoogleOAuthProvider>
      </OAuthUpdateContext.Provider>
    </OAuthContext.Provider>
  )
}


// ================================= HELPERS =================================
/*
function googleAuthButton() {

  const handleCredentialResponse = useCredentialResponseHandler();

  const buttonRef = useRef<any>( null );

  const initializeButton = () => {

    if( buttonRef.current ) {
      buttonRef.current.setAttribute("class", "g_id_signin"); // Required Class
      buttonRef.current.setAttribute("id", "g_id_onload"); // Required ID
      buttonRef.current.setAttribute("data-client_id", CLIENT_ID);
      buttonRef.current.setAttribute("data-type", "standard");
      buttonRef.current.setAttribute("data-size", "large");
      buttonRef.current.setAttribute("data-width", "250");
      buttonRef.current.setAttribute("data-theme", "filled_blue");
      buttonRef.current.setAttribute("data-text", "continue_with");
      buttonRef.current.setAttribute("data-shape", "rectangular");
      buttonRef.current.setAttribute("data-logo_alignment", "left");
      buttonRef.current.setAttribute("data-callback", "handleCredentialResponse");
      window.handleCredentialResponse = handleCredentialResponse; // Need public for ^ to work
      console.log("!!! BUTTON REF UPDATED !!!");
    }
    else { console.log("BUTTON REF CURRENT IS NULL... ", buttonRef); }

  };


  loadScript( GOOGLE_OAUTH_SCRIPT_SOURCE ).then( () => {
    console.log("INITILAIZED FROM LOAD SCRIPT CALLBACK");
    initializeButton();
  }).catch( console.error ); // TODO: Error Handle

  return (
    <button className="google-login-button">
      <p> HI THERE LOADING </p>
      <div ref={buttonRef}></div>
    </button>
  );
}
*/
function useGoogleAuth( credentialResponseHandler: any ) {

  const buttonRef = useRef<any>( null );

  const GoogleAuth = () => {
    const src = "https://accounts.google.com/gsi/client";

    const initializeButton = () => {

      if( buttonRef.current ) {
        buttonRef.current.setAttribute("class", "g_id_signin"); // Required Class
        buttonRef.current.setAttribute("id", "g_id_onload"); // Required ID
        buttonRef.current.setAttribute("data-client_id", CLIENT_ID);
        buttonRef.current.setAttribute("data-type", "standard");
        buttonRef.current.setAttribute("data-size", "large");
        buttonRef.current.setAttribute("data-width", "250");
        buttonRef.current.setAttribute("data-theme", "filled_blue");
        buttonRef.current.setAttribute("data-text", "continue_with");
        buttonRef.current.setAttribute("data-shape", "rectangular");
        buttonRef.current.setAttribute("data-logo_alignment", "left");
        buttonRef.current.setAttribute("data-callback", "handleCredentialResponse");
        window.handleCredentialResponse = credentialResponseHandler; // Need public for ^ to work
      }
      else { 
        //console.log("BUTTON REF CURRENT IS NULL... ", buttonRef);
      }

    };

    useEffect( () => {
      loadScript( src ).then( () => {
        initializeButton();
      }).catch( console.error ); // TODO: Error Handle

      // Cleanup Function
      return () => {
        const scriptTag = document.querySelector( `script[src="${src}"]` );
        if( scriptTag ) {
          document.body.removeChild( scriptTag ); 
          //console.log("SCIRPT REMOVED");
        }
      };

    }, [] );

    return (
      <button className="google-login-button">
        <p> HI THERE LOADING </p>
        <div ref={buttonRef}></div>
      </button>
    );
  }

  return { GoogleAuth };
}


function useCredentialResponseHandler( updateUser: any ) {

  //const { updateUser } = useUserUpdate();

  const handleCredentialResponse = ( response: any ) => {

    const responsePayload = parseJwt(response.credential); // Decode Credential Response
    console.log(responsePayload);

    /* TID BITS FROM QUALITY SOURCES
    - Save Credential Object in my DB after every API Request to get Creds (to ensure got latest)
    - After VERIFIED TOKEN, check if User already in my User DB
    -- Yes? Establish an Authenticated Session for User
    -- No? Create new User Record from Info in the ID Token Payload AND establish Session for User
    --- Can Prompt User for any additional Profile Info you Require for your App
    */

    // USE "sub(ject)" as User ID to store Info, NOT Email (as that can change later)
    /*
    console.log("ID: " + responsePayload.sub);
    console.log('Full Name: ' + responsePayload.name);
    console.log('Given Name: ' + responsePayload.given_name);
    console.log('Family Name: ' + responsePayload.family_name);
    console.log("Image URL: " + responsePayload.picture);
    console.log("Email: " + responsePayload.email);
    */

    const user: IUser = {
      externalId: responsePayload.sub,

      email: responsePayload.email,
      name: responsePayload.given_name,
      firstName: responsePayload.given_name,
      lastName: responsePayload.family_name,
      avatarURL: responsePayload.picture,

      loginMethod: LoginMethod.GOOGLE,
    };

    postToLoginEndpoint( user, updateUser );

    // TODO: TEMPORARY -- Find better way where after Login for BOTH FB and Google and all... it closes the Modal ...
    const modal = document.getElementById("log-in_modal");
    if( modal != null ) {
      modal.style.display = "none";
      document.body.style.overflow = "auto";
    }
  }

  return handleCredentialResponse;
}


const loadScript = (src: string) => {
  return new Promise( (resolve: any, reject: any) => {
    if( document.querySelector(`script[src="${src}"]`) ) {
      //console.log("############ SCRIPT TAG EXISTS ALREADY ###############");
      return resolve();
    }

    const script = document.createElement( "script" );
    script.src = src;
    script.onload = () => resolve();
    script.onerror = err => reject( err );
    document.body.appendChild( script );
  });
}

// Source: https://stackoverflow.com/a/38552302/7318703
function parseJwt( token: string ) {
  var base64URL = token.split('.')[1];
  var base64 = base64URL.replace(/-/g, '+').replace(/_/g, '/');
  var jsonPayload = decodeURIComponent(window.atob(base64).split('').map(function(c) {
      return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
  }).join(''));

  return JSON.parse(jsonPayload);
}


type UserSetterFunction = ( user: IUser ) => null;
async function postToLoginEndpoint( user: IUser, userSetter: UserSetterFunction ) {
  // TODO: ERROR HANDLE
  if( user.externalId == null ) {
    //console.log("EXTERNAL ID IS NULL"); console.log(user);
    return;
  }

  const response = await fetch( "/login", {
    method: "POST",
    headers: {
      "Content-Type": "application/json"
    },
    body: JSON.stringify(user),
    credentials: "include"
  });

  const responseJSON = await response.json();
  console.log( "Login Response:", responseJSON );

  if( responseJSON.success ) {
    console.log( "Storing in LocalStorage" );
    //localStorage.setItem( "user", JSON.stringify(responseJSON.user) );
    userSetter( user );
  }
  else {
    console.error("FAILED TO LOGIN", responseJSON);
  }
}




/**/
